import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import { fontFamilyHelvetica } from "@styles/type.styles";
import { colors } from "@styles/color.styles";
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";

type FlexibilityLearnMoreProps = {
  onFlexibilityFaqSelect?: () => void;
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
  },
  body: {
    fontFamily: fontFamilyHelvetica,
    color: colors.green.darker,
    fontSize: `${12 / 16}rem`,
    lineHeight: "20px",
    textDecoration: "underline",
    margin: "0px 4px",
  },
});

export const FlexibilityLearnMore = ({ onFlexibilityFaqSelect }: FlexibilityLearnMoreProps) => {
  const classes = useStyles();

  // TODO: (nikita) replace ✨ with svg
  return (
    <div
      className={classes.container}
      onClick={() => {
        onFlexibilityFaqSelect && onFlexibilityFaqSelect();
      }}
    >
      ✨
      <a
        className={classes.body}
        href={articleUrls.flexibilityFaq}
        target="_blank"
        cw-id="flexibility-learn-more-link"
      >
        What meetings should I mark flexible?
      </a>
      ✨
    </div>
  );
};
